import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Strengths from './components/Strengths';
import Materials from './components/Materials';
import Markets from './components/Markets';
import Applications from './components/Applications';
import Vision from './components/Vision';
import Warehouse from './components/Warehouse';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <Header />
      <main>
        <Hero />
        <About />
        <Strengths />
        <Materials />
        <Markets />
        <Applications />
        <Vision />
        <Warehouse />
        <Contact />
      </main>
      <Footer />
    </LanguageProvider>
  );
}

export default App;
